import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "275",
  height: "174"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "wblvq7shja",
        x1: "-4.623%",
        x2: "86.992%",
        y1: "70.046%",
        y2: "36.573%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#D8E5C4"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#D8E5C4",
          "stop-opacity": ".25"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#wblvq7shja)",
      "fill-rule": "evenodd",
      d: "M63.712 0c104.77 0 192.034 74.883 211.092 174h-46.92c-18.25-73.629-84.831-128.21-164.172-128.21-22.538 0-44.047 4.404-63.712 12.398V9.59C20.132 3.357 41.53 0 63.712 0",
      transform: "matrix(1 0 0 -1 -.003 174)"
    }, null, -1)
  ])))
}
export default { render: render }